<template>
  <div class="basic_con">
    <Frame title="历史项目">
      <template slot="contentSlot">
        <div class="con_wrapper">
          <div class="total_limit">保理额度总计：{{ allCount }}</div>
          <el-table :data="tableData" border>
            <el-table-column
              type="index"
              width="40"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="projectName"
            
              label="项目名称"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="factoringCredit"
              label="保理额度（元）"
              align="center"
              width="120"
            >
            </el-table-column>
          </el-table>
        </div>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "../../frame.vue";
import {
  getAuditedListByCustId,
  deleteFactoring,
} from "@/api/factoring/factoring";
import { floatAdd } from "@/util/util";
export default {
  name: "customerGrade",
  components: {
    Frame,
  },
  data() {
    return {
      tableData: [],
      allCount: 0,
    };
  },
  mounted() {
    this.queryTableData();
  },
  computed: {
    conversion() {
      return function (val, company = 1) {
        return val > 0
          ? Intl.NumberFormat("en", { maximumFractionDigits: 2 }).format(
              (Number(val) / company).toFixed(2)
            )
          : val;
      };
    },
  },
  methods: {
    async queryTableData() {
      this.loading = true;
      let params = {
        custId: this.$route.params.id,
      };
      let res = await getAuditedListByCustId(params);
      if (res.data.code == 200) {
        let allCount = 0;
        let data = res.data.data;
        data.map((item) => {
          allCount =floatAdd(allCount,Number(item.factoringCredit)) ;
        });
        this.allCount = allCount;
        this.tableData = data;
        // this.page.total = data.length;
        this.loading = false;
      } else {
        this.$message.error(res.data.msg);
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.basic_con {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 10px;
  height: 397px;
}
.con_wrapper {
  text-align: center;
  padding: 10px 0px;
  height: 310px;
  overflow: scroll;
}
.total_limit {
  display: inline-block;
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  padding: 4px 10px;
  background-color: #6393cc;
  margin-bottom: 20px;
  border-radius: 5px;
}
/deep/ .el-table th {
  background: #ffffff;
  color: #999999;
}
/deep/ .el-table {
  font-size: 12px;
}
</style>

